export function StatusBadge({ value, label = value }: { value: string; label?: string }) {
  const normalized = value.toLowerCase().replaceAll('_', '-')
  return <span className={`status-badge status-${normalized}`}>{label.replaceAll('_', ' ')}</span>
}
